var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alerts, Warning, Signs Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5ZM11.7109 10.1641C11.2838 9.73697 10.5912 9.73697 10.1641 10.1641C9.73697 10.5912 9.73697 11.2838 10.1641 11.7109L15.9532 17.5L10.1641 23.2891C9.73697 23.7162 9.73697 24.4088 10.1641 24.8359C10.5912 25.263 11.2838 25.263 11.7109 24.8359L17.5 19.0468L23.2891 24.8359C23.7162 25.263 24.4088 25.263 24.8359 24.8359C25.263 24.4088 25.263 23.7162 24.8359 23.2891L19.0468 17.5L24.8359 11.7109C25.263 11.2838 25.263 10.5912 24.8359 10.1641C24.4088 9.73697 23.7162 9.73697 23.2891 10.1641L17.5 15.9532L11.7109 10.1641Z",
    fill: "#D00026"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLoading);
export default __webpack_public_path__ + "static/media/errorLoading.3863a335dcfa4e95a43f85141408a449.svg";
export { ForwardRef as ReactComponent };